"use strict";
/**
 *
 * FormSelectField/useFormSelectField
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const FormField_1 = require("../FormField");
function useFormSelectField(props) {
    const { required } = props, formFieldProps = __rest(props, ["required"]);
    const formField = FormField_1.useFormField(formFieldProps);
    const [selectEl, setSelectEl] = react_1.useState(null);
    const { validityMessage } = formField.state;
    react_1.useEffect(() => {
        if (selectEl) {
            selectEl.setCustomValidity(validityMessage || '');
            if (validityMessage) {
                selectEl.reportValidity();
            }
        }
    }, [validityMessage || '']);
    const handleChange = react_1.useCallback(({ currentTarget }) => {
        formField.setValue(currentTarget.value || null);
        // we want this asynchronously called because some browsers (safari) decide to hide the validity box on input
        const { validity } = currentTarget;
        if (!validity.valid) {
            const reportValidity = () => currentTarget.reportValidity();
            setTimeout(reportValidity, 0);
        }
    }, [formField.setValue]);
    return Object.assign(Object.assign({}, formField), { selectProps: {
            name: formFieldProps.path,
            value: formField.value || '',
            required,
            disabled: formField.state.disabled,
            readOnly: formField.state.readOnly,
            ref: setSelectEl,
            onChange: handleChange,
        } });
}
exports.useFormSelectField = useFormSelectField;
